/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    numberHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.#',
        defaultMessage: '#'
    },
    yearHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Year',
        defaultMessage: 'Year'
    },
    brandHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Brand',
        defaultMessage: 'Brand'
    },
    motorTypeHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Motor Type',
        defaultMessage: 'Motor Type'
    },
    horsePowerHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Horsepower',
        defaultMessage: 'Horsepower'
    },
    serialNumberHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Serial Number',
        defaultMessage: 'Serial Number'
    },
    currentMarketValueHeader: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Current Market  Value ($)',
        defaultMessage: 'Current Market  Value ($)'
    },
     add: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Add',
        defaultMessage: 'Add'
    },
     addAuxMotor: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Add Auxiliary Motors',
        defaultMessage: 'Add Auxiliary Motors'
    },
    removeAuxMotor: {
        id: 'quoteandbind.PPLProLinedirectives.templates.AuxiliaryMotors.Remove Aux Motor',
        defaultMessage: 'Removed Auxiliary Motor {brandDesc}'
    }
});